// extracted by mini-css-extract-plugin
module.exports = {"lottery":"index_lottery_x7D1o","btn-more":"index_btn-more_VcgTr","btn-award":"index_btn-award_3k-L4"};